import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'

import SWLogin from '../components/Auth/SWLogin'
import SWRegister from '../components/Auth/SWRegister'
import Login from '../components/Auth/Login'
import Recovery from '../components/Auth/PasswordRecovery'
import ResetPassword from '../components/Auth/PasswordReset'
import Main from '../components/Main'
import Dashboard from '../components/Dashboard'
import Users from '../components/Users/Users'
import UsersList from '../components/Users/UsersList'
import UserCreate from '../components/Users/UserCreate'
import UserEdit from '../components/Users/UserEdit'
import Auctions from '../components/Auctions/Auctions'
import AuctionBrands from '../components/Auctions/Brand/AuctionBrands'
import AuctionModels from '../components/Auctions/Model/AuctionModels'
import AuctionSpecifications from '../components/Auctions/Specification/AuctionSpecifications'
import AuctionLocations from '../components/Auctions/Locations/AuctionLocations'
import Bids from '../components/Bids/Bids'
import BidsList from '../components/Bids/BidsList'
import Favorites from '../components/Favorites/Favorites'
import FavoritesList from '../components/Favorites/FavoritesList'
import SearchResult from '../components/Auctions/Results/SearchResult'
import History from '../components/History/History'
import HistoryList from  '../components/History/HistoryList'
import HomePage from '../components/Home/HomePage'
import SingleLot from '../components/Auctions/Lot/Lot'
import Register from '../components/Auth/Register'
import Cars from '../components/Cars/Cars'
import CarsList from '../components/Cars/CarsList'
import SingleCar from '../components/Cars/Car/Car'
import CarCreate from '../components/Cars/Create/CarCreate'
import Profile from '../components/Profile/Profile'
import PricePlans from '../components/ControlPanel/PricePlans/PricePlans'
import PlansList from '../components/ControlPanel/PricePlans/PlansList'
import NewPricePlan from '../components/ControlPanel/PricePlans/NewPlan/NewPricePlan'
import Invoices from '../components/ControlPanel/Invoices/Invoices'
import InvoicesList from '../components/ControlPanel/Invoices/InvoicesList'
import Rates from '../components/ControlPanel/Rates/Rates'
import Requests from '../components/ControlPanel/Requests/Requests'
import Tools from '../components/Tools/Tools.vue'
import InlandPrices from '../components/ControlPanel/InlandPrices/InlandPrice'
import InlandCompanies from '../components/ControlPanel/InlandComapnies/InlandCompanies'
import UserMessages from '../components/Users/User/Messages/UserMessages'
import UserMessagesThread from '../components/Users/User/Messages/Thread/Thread'
import AdvanceSearch from '../components/Auctions/Advance/AdvanceSearch'
import RecFee from '../components/ControlPanel/RecFee/RecFee'
import RecFeeList from '../components/ControlPanel/RecFee/RecFeeList'
import Purchases from '../components/ControlPanel/Purchases/Purchases'
import PurchasesList from '../components/ControlPanel/Purchases/PurchasesList'
import Jibaiseki from '../components/ControlPanel/Jibaiseki/Jibaiseki'
import JibaisekiList from '../components/ControlPanel/Jibaiseki/JibaisekiList'
import Profit from '../components/ControlPanel/Profit/Profit'
import ProfitList from '../components/ControlPanel/Profit/ProfitList'
import UserOther from "../components/Users/User/Tabs/Other/UserOther";
import StockCars from "../components/StockCars/StockCars";
import StockCar from "../components/StockCars/StockCar";
import Banking from "../components/Banking/Banking";
import Transactions from "../components/Banking/Transactions";
import CreateTransaction from "../components/Banking/CreateTransaction";
import EditTransaction from "../components/Banking/EditTransaction";
import BalanceStatement from "../components/Balance-Statement/BalanceStatement";
import TransactionsUser from "../components/UserBanking/TransactionsUser";
import Statement from "../components/Statement/Statement";
import TransactionsClient from "../components/Balance-Statement/TransactionsClient";
import CreateClientTransaction from "../components/Balance-Statement/CreateClientTransaction";
import CreateClientRefundTransaction from "../components/Balance-Statement/CreateClientRefundTransaction";
import EditClientRefundTransaction from "../components/Balance-Statement/EditClientRefundTransaction";
import EditClientTransaction from "../components/Balance-Statement/EditClientTransaction";
import CreateRefundTransaction from "../components/Banking/CreateRefundTransaction";
import EditRefundTransaction from "../components/Banking/EditRefundTransaction";

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/system',
            name: 'Main',
            component: Main,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: '',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: '/auctions',
                    name: 'Auctions',
                    component: Auctions,
                    children: [
                        {
                            path: '',
                            name: 'Brands',
                            component: AuctionBrands
                        },
                        {
                            path: 'models/:id',
                            name: 'Models',
                            component: AuctionModels
                        },
                        {
                            path: 'models',
                            name: 'Models',
                            component: AuctionModels
                        },
                        {
                            path: 'specifications',
                            name: 'Specifications',
                            component: AuctionSpecifications
                        },
                        {
                            path: 'locations',
                            name: 'Locations',
                            component: AuctionLocations
                        },
                        {
                            path: 'searchResults',
                            name: 'SearchResult',
                            component: SearchResult,
                        },
                        {
                            path: 'advance',
                            name: 'AdvanceSearch',
                            component: AdvanceSearch,
                        },

                    ]
                },
                {
                    path: '/single/:id',
                    name: 'SingleLot',
                    component: SingleLot
                },
                {
                    path: '/buy-now/:id',
                    name: 'StockCar',
                    component: StockCar
                },
                {
                    path: '/users',
                    name: 'Users',
                    component: Users,
                    children: [
                        {
                            path: '',
                            name: 'UsersList',
                            component: UsersList
                        },
                        {
                            path: 'create',
                            name: 'CreateUser',
                            component: UserCreate
                        },
                        {
                            path: 'edit/:id',
                            name: 'EditUser',
                            component: UserEdit
                        },
                        {
                            path: 'messages/:id',
                            name: 'UserMessages',
                            component: UserMessages
                        },
                        {
                            path: 'thread/:id',
                            name: 'UserMessagesThread',
                            component: UserMessagesThread,
                            props: true
                        },
                        {
                            path: 'other/:id',
                            name: 'UserOther',
                            component: UserOther
                        }
                    ]
                },
                {
                    path: '/buy-now',
                    name: 'Buy Now',
                    component: StockCars,
                }/*,
                {
                    path: '/one-price-list',
                    name: 'One Price List',
                    component: OnePriceList,
                    children: [
                        {
                            path: 'advance',
                            name: 'AdvanceSearch',
                            component: AdvanceSearch,
                        }
                    ]
                }*/,
                {
                    path: '/bids',
                    name: 'Bids',
                    component: Bids,
                    children: [
                        {
                            path: '',
                            name: 'BidsList',
                            component: BidsList
                        }
                    ]
                },
                {
                    path: '/favorites',
                    name: 'Favorites',
                    component: Favorites,
                    children: [
                        {
                            path: '',
                            name: 'FavoritesList',
                            component: FavoritesList
                        }
                    ]
                },
                {
                    path: '/history',
                    name: 'History',
                    component: History,
                    children: [
                        {
                            path: '',
                            name: 'HistoryList',
                            component: HistoryList
                        }
                    ]
                },
                {
                    path: '/banking',
                    name: 'Banking',
                    component: Banking,
                    children: [
                        {
                            path: '',
                            name: 'Transactions',
                            component: Transactions
                        },
                        {
                            path: 'create',
                            name: 'CreateTransaction',
                            component: CreateTransaction
                        },
                        {
                            path: 'edit/:id',
                            name: 'EditTransaction',
                            component: EditTransaction
                        },
                        {
                            path: 'create-refund',
                            name: 'CreateRefundTransaction',
                            component: CreateRefundTransaction
                        },
                        {
                            path: 'edit-refund/:id',
                            name: 'EditRefundTransaction',
                            component: EditRefundTransaction
                        }
                    ]
                },
                {
                    path: '/balance-statement',
                    name: 'Balance-Statement',
                    component: BalanceStatement,
                    children: [
                        {
                            path: '',
                            name: 'TransactionsClient',
                            component: TransactionsClient
                        },
                        {
                            path: 'create/:id',
                            name: 'CreateClientTransaction',
                            component: CreateClientTransaction
                        },
                        {
                            path: 'edit/:id',
                            name: 'EditClientTransaction',
                            component: EditClientTransaction
                        },
                        {
                            path: 'create-refund/:id',
                            name: 'CreateClientRefundTransaction',
                            component: CreateClientRefundTransaction
                        },
                        {
                            path: 'edit-refund/:id',
                            name: 'EditClientRefundTransaction',
                            component: EditClientRefundTransaction
                        }
                    ]
                },
                {
                    path: '/statement',
                    name: 'Statement',
                    component: Statement,
                   /* children: [
                        {
                            path: '',
                            name: 'CreateTransaction',
                            component: CreateTransaction
                        },
                        {
                            path: 'create/:id',
                            name: 'CreateClientTransaction',
                            component: CreateClientTransaction
                        },
                        {
                            path: 'edit/:id',
                            name: 'EditClientTransaction',
                            component: EditClientTransaction
                        }
                    ]*/
                },
                {
                    path: '/cars',
                    name: 'Cars',
                    component: Cars,
                    children: [
                        {
                            path: '',
                            name: 'CarsList',
                            component: CarsList
                        },
                        {
                            path: 'create',
                            name: 'CarCreate',
                            component: CarCreate
                        }
                    ]
                },
                {
                    path: '/car/:id',
                    name: 'SingleCar',
                    component: SingleCar
                },
                {
                    path: '/profile',
                    name: 'Profile',
                    component: Profile,
                },
                {
                    path: '/plans',
                    name: 'PricePlans',
                    component: PricePlans,
                    children: [
                        {
                            path: '',
                            name: 'PlansList',
                            component: PlansList
                        },
                        {
                            path: 'new',
                            name: 'NewPricePlan',
                            component: NewPricePlan
                        },
                        {
                            path: 'edit/:id',
                            name: 'EditPricePlan',
                            component: NewPricePlan
                        },
                    ]
                },
                {
                    path: '/rates',
                    name: 'Rates',
                    component: Rates
                },
                {
                    path: '/requests',
                    name: 'Requests',
                    component: Requests
                },
                {
                    path: '/tools',
                    name: 'Tools',
                    component: Tools
                },
                {
                    path: '/inland',
                    name: 'InlandPrices',
                    component: InlandPrices
                },
                {
                    path: '/companies',
                    name: 'InlandCompanies',
                    component: InlandCompanies
                },
                {
                    path: '/invoices',
                    name: 'Invoices',
                    component: Invoices,
                    children: [
                        {
                            path: '',
                            name: 'InvoicesList',
                            component: InvoicesList
                        }
                    ]
                },
                {
                    path: '/rec',
                    name: 'RecFee',
                    component: RecFee,
                    children: [
                        {
                            path: '',
                            name: 'RecFeeList',
                            component: RecFeeList
                        }
                    ]
                },
                {
                    path: '/purchases',
                    name: 'Purchases',
                    component: Purchases,
                    children: [
                        {
                            path: '',
                            name: 'PurchasesList',
                            component: PurchasesList
                        }
                    ]
                },
                {
                    path: '/jibaiseki',
                    name: 'Jibaiseki',
                    component: Jibaiseki,
                    children: [
                        {
                            path: '',
                            name: 'JibaisekiList',
                            component: JibaisekiList
                        }
                    ]
                },
                {
                    path: '/profit',
                    name: 'Profit',
                    component: Profit,
                    children: [
                        {
                            path: '',
                            name: 'ProfitList',
                            component: ProfitList
                        }
                    ]
                },
            ]
        },
        {
            path: '/sw-login',
            name: 'SWLogin',
            component: SWLogin
        },
        {
            path: '/sw-register',
            name: 'SWRegister',
            component: SWRegister
        },
        {
            path: '/sw-register',
            name: 'Register',
            component: Register
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/login/recover',
            name: 'Recovery',
            component: Recovery
        },
        {
            path: '/password/reset/:token',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/',
            mame: 'HomePage',
            component: HomePage
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        store.dispatch('validateToken')
        if (!store.getters.getTokenStatus) {
            next({ name: 'Login', params: { nextUrl: to.fullPath } })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js